module.exports = {"login":{"loginbutton":"Einloggen","title":"Einloggen","emailinput":"E-Mail-Addresse","passwordinput":"Passwort","forgotPasswordLegend":"Ich habe mein Passwort vergessen","registernewuser":"Neuer Benutzer? hier registrieren"},"languages":{"English":"English (En)","Spanish":"Spanish (Es)","Brazil":"Brazil (Pt)","French":"French (Fr)","German":"German (Ge)","Japanese":"Japanese (Jp)","Chinese":"Chinese (Zh)","Polish":"Polish (Pl)"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/pt-BR.json
// module id = 1114
// module chunks = 31